<template>
  <v-container class="my-16 mx-auto">
    <h1>出展</h1>
    <h2>-参加企業-</h2>
    <!-- <ComingSoon /> -->
    <LogoList />
    <h2>-タイトル-</h2>
    <CompanyList />
    <TopButton />
    <!-- <TitleList /> -->
  </v-container>
</template>

<script>
  import CompanyList from "./ExCompany.vue";
  import LogoList from "./LogoList.vue";
  import TopButton from "./TopButton.vue";
  //import ComingSoon from "./ComingSoon.vue";
  // import TitleList from "./TitleList.vue";

  export default {
    name: "App",
    components: {
      LogoList,
      CompanyList,
      TopButton,
      // ComingSoon,
      //TitleList,
    },
  };
</script>
<style lang="css" scoped>
  h2 {
    text-align: center;
    letter-spacing: 0.2em;
    margin: 1em;
  }
</style>
